import React from 'react';

const VARIANTS = {
  primary: 'bg-primary text-white hover:bg-primary-light focus:ring-primary/40',
  secondary: 'bg-slate-100 text-ink hover:bg-slate-200 focus:ring-slate-300',
  accent: 'bg-accent text-primary-dark hover:bg-accent-dark hover:text-white focus:ring-accent/40',
  danger: 'bg-danger text-white hover:bg-red-600 focus:ring-danger/40',
  success: 'bg-success text-white hover:bg-green-600 focus:ring-success/40',
  ghost: 'bg-transparent text-ink hover:bg-slate-100 focus:ring-slate-300',
  outline: 'border border-slate-300 bg-white text-ink hover:bg-slate-50 focus:ring-slate-300',
};

const SIZES = {
  sm: 'px-2.5 py-1.5 text-xs',
  md: 'px-4 py-2 text-sm',
  lg: 'px-5 py-2.5 text-sm',
};

export default function Button({
  variant = 'primary',
  size = 'md',
  type = 'button',
  className = '',
  disabled = false,
  loading = false,
  icon: Icon,
  iconRight: IconRight,
  children,
  ...rest
}) {
  const base =
    'inline-flex items-center justify-center gap-2 rounded-md font-medium transition-colors focus:outline-none focus:ring-2 disabled:cursor-not-allowed disabled:opacity-50';
  return (
    <button
      type={type}
      disabled={disabled || loading}
      className={`${base} ${VARIANTS[variant] || VARIANTS.primary} ${SIZES[size] || SIZES.md} ${className}`}
      {...rest}
    >
      {Icon && !loading && <Icon className="text-base" />}
      {loading && (
        <span className="inline-block h-3.5 w-3.5 animate-spin rounded-full border-2 border-current border-t-transparent" />
      )}
      {children}
      {IconRight && <IconRight className="text-base" />}
    </button>
  );
}
